import { toast } from 'react-toastify';
import { createListenerMiddleware } from '@reduxjs/toolkit';
import { TypedStartListening } from '@reduxjs/toolkit';
import { ApplicationDispatch, ApplicationState } from '@/store';
import { apiService } from './apiService';
import { getErrorMessage } from '@/utils/helpers';

export const apiServiceListener = createListenerMiddleware();
export const apiServiceStartListening = apiServiceListener.startListening as TypedStartListening<
    ApplicationState,
    ApplicationDispatch
>;

apiServiceStartListening({
    matcher: apiService.endpoints.syncMailchimpUsers.matchFulfilled,
    effect: async (action, api) => {
        toast.success('Success', { autoClose: 5000 });
    },
});
apiServiceStartListening({
    matcher: apiService.endpoints.postDiscountAgreements.matchFulfilled,
    effect: async (action, api) => {
        // @ts-ignore
        const response: any = action.meta.baseQueryMeta?.response;

        if (response.status === 204) {
            toast.info(response.statusText, { autoClose: 5000 });
        } else {
            toast.success('Success', { autoClose: 5000 });
        }
    },
});
apiServiceStartListening({
    matcher: apiService.endpoints.syncMailchimpUsers.matchRejected,
    effect: async (action, api) => {
        // @ts-ignore
        if (action.payload?.data?.ResponseStatus?.Message) {
            // @ts-ignore
            toast.error(action.payload.data.ResponseStatus.Message, { autoClose: 5000 });
        } else if (action.payload?.status === 401) {
            toast.error(`${action.payload?.status} unauthorized`, { autoClose: 5000 });
        } else {
            // @ts-ignore
            toast.error(action.payload?.error, { autoClose: 5000 });
        }
    },
});
apiServiceStartListening({
    matcher: apiService.endpoints.deleteDiscountAgreements.matchRejected,
    effect: async (action, api) => {
        toast.error(getErrorMessage(action.payload), { autoClose: 5000 });
    },
});
